//primeReact
import { Dialog } from "primereact/dialog"
import { PickList } from "primereact/picklist"
import { useContext } from "react"
import { UserContext } from "../../../context/userContext"

import { useState } from "react"
import { useEffect } from "react"

import { docSigningApiUpdateTemplateOrganizationsPost } from "../documentsApi"
import { LogError } from "../../../helpers/logger"

export default function EditTemplateGroups({
  template,
  showDialog,
  onSetShowDialog,
  onChangesSubmitted,
  organizations,
}) {
  const userCtx = useContext(UserContext)

  const [availableOrgs, setAvailableOrgs] = useState([])
  const [selectedOrgs, setSelectedOrgs] = useState([])
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!!template) {
      if (template.additionalOrganizations?.length > 0) {
        setAvailableOrgs(
          organizations.filter(
            (org) =>
              org.organization_id !== org.enterprise_id &&
              !template.additionalOrganizations.some(
                (add) => add === org.organization_id
              )
          )
        )
        setSelectedOrgs(
          organizations.filter((org) =>
            template.additionalOrganizations.some(
              (add) => add === org.organization_id
            )
          )
        )
      } else {
        setAvailableOrgs(organizations)
        setSelectedOrgs([])
      }
    } else {
      setAvailableOrgs(organizations)
      setSelectedOrgs([])
    }
  }, [organizations, template, showDialog])

  async function submitChanges() {
    try {
      setSubmitting(true)
      const newGroupIds = selectedOrgs.map((org) => org.organization_id)

      let body = {
        groupId: userCtx.session.user.organization_id,
        userId: userCtx.session.user.staff_id,
        additionalGroupIds: newGroupIds,
      }

      await docSigningApiUpdateTemplateOrganizationsPost(
        userCtx.tokenDocumentSign,
        body,
        template.templateId
      )

      onChangesSubmitted()
      onSetShowDialog(false)

      setSubmitting(false)
    } catch (error) {
      userCtx.setNotificationError(
        "Unable to submit organization allocation changes"
      )
      LogError("Unable to submit organization allocation changes", error)
      setSubmitting(false)
    }
  }

  function OrganizationTemplate(org) {
    return <>{org.organization_name}</>
  }

  return (
    <Dialog
      header={"Update organization allocation"}
      visible={showDialog}
      onHide={() => {
        onSetShowDialog(false)
      }}
    >
      <PickList
        source={availableOrgs}
        sourceHeader="Available organizations"
        showSourceControls={false}
        target={selectedOrgs}
        targetHeader="Allocated organization"
        showTargetControls={false}
        onChange={(event) => {
          setAvailableOrgs(event.source)
          setSelectedOrgs(event.target)
        }}
        itemTemplate={OrganizationTemplate}
        style={{ height: "500px" }}
        metaKeySelection={true}
        filterBy="organization_name"
        sourceFilterPlaceholder="Search by name"
        targetFilterPlaceholder="Search by name"
      />
      <div style={{ float: "right" }}>
        <button
          type="button"
          className="btn"
          onClick={() => {
            submitChanges()
          }}
          disabled={submitting}
        >
          Submit
        </button>
        <button
          type="button"
          className="btn"
          style={{ marginLeft: "10px" }}
          onClick={() => {
            onSetShowDialog(false)
          }}
          disabled={submitting}
        >
          Cancel
        </button>
      </div>
    </Dialog>
  )
}
